import { useState } from "react";
import { Check, Link2, Share2 } from "lucide-react";
import { toast } from "sonner";

const T = {
  pl: { label: "Udostępnij", copy: "Kopiuj link", copied: "Link skopiowany", native: "Udostępnij…", fail: "Nie udało się skopiować linku" },
  en: { label: "Share", copy: "Copy link", copied: "Link copied", native: "Share…", fail: "Could not copy the link" },
};

const IconLinkedIn = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z" /></svg>;
const IconFacebook = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.32l-.53 3.49h-2.79V24C19.61 23.1 24 18.1 24 12.07z" /></svg>;
const IconX = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.9 1.15h3.68l-8.04 9.19L24 22.85h-7.4l-5.8-7.58-6.64 7.58H.47l8.6-9.83L0 1.15h7.59l5.24 6.93 6.07-6.93zm-1.29 19.5h2.04L6.49 3.24H4.3l13.31 17.41z" /></svg>;

const btn = "inline-flex items-center gap-2 rounded-full border border-border bg-card px-4 py-2 text-xs font-semibold hover:border-brand-teal hover:text-brand-teal transition-colors";

export default function ShareBar({ url, title, lang = "pl", testid = "share-bar" }) {
  const t = T[lang] || T.en;
  const [copied, setCopied] = useState(false);
  const enc = encodeURIComponent;
  const canNative = typeof navigator !== "undefined" && !!navigator.share;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success(t.copied);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error(t.fail);
    }
  };
  const native = () => navigator.share({ title, url }).catch(() => {});

  return (
    <div data-testid={testid} className="mt-10 flex flex-wrap items-center gap-2">
      <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-semibold mr-2"><Share2 size={12} /> {t.label}</span>
      <a data-testid={`${testid}-linkedin`} className={btn} href={`https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><IconLinkedIn /> LinkedIn</a>
      <a data-testid={`${testid}-facebook`} className={btn} href={`https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><IconFacebook /> Facebook</a>
      <a data-testid={`${testid}-x`} className={btn} href={`https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}`} target="_blank" rel="noopener noreferrer" aria-label="X"><IconX /> X</a>
      <button type="button" data-testid={`${testid}-copy`} onClick={copy} className={btn}>{copied ? <Check size={14} className="text-brand-teal" /> : <Link2 size={14} />} {copied ? t.copied : t.copy}</button>
      {canNative && <button type="button" data-testid={`${testid}-native`} onClick={native} className={`${btn} sm:hidden`}><Share2 size={14} /> {t.native}</button>}
    </div>
  );
}
